<template>
  <div class="admin col-12">
    <div class="row">
      <div class="col-3">
        <div class="row">
          <div class="col-12 row-header"> Pot Internal Watering Set Up </div>
        </div>
        <div class="scrolling-table" v-show="!loading">
          <template v-for="temp in pot_internals">
            <div
              class="row clickable"
              :key="temp.id"
              v-show="temp.active == !show_deleted"
              v-bind:class="{ selected: temp == item }"
              @click="_itemSelected(temp)"
            >
              <div class="col-12">
                {{ temp.description }}
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="col-9">
        <div class="row">

          <PotInternalDetail
            :selectedItem="item"
            class="col-12"
            v-show="showPotInternalDetail"
            ref="pot_internal"
            @new="_new_item"
          />

        </div>
      </div>
    </div>

    <CreatePotInternal
      ref="pot_internals_modal"
      v-show="showCreatePotInternal"
      @close="_closeNewModal"
    />

    <div class="row">
      <div class="col-3">
        <input type="checkbox" id="show_deleted" @click="_show_deleted" />
        <label for="show_deleted">Show Deleted</label>
      </div>
    </div>
  </div>
</template>

<script>
import PotInternalDetail from "@/components/admin/inventory/detail/PotInternalDetail.vue";
import CreatePotInternal from "@/components/admin/inventory/create/CreatePotInternal.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "ManagePotInternal",

  // DATA
  data: () => ({
    item: null,
    loading: false,
    show_deleted: false,
    showCreatePotInternal: false,
    showPotInternalDetail: true,
  }),

  // COMPUTED
  computed: {
    ...mapState("inventory", ["pot_internals", "new_pot_internal"]),
  },

  // MOUNTED
  mounted() {
    this.$nextTick(() => {
      this.getPotInternals();
    });
  },

  // WATCH
  watch: {
    new_pot_internal(new_value) {
      this.item = new_value;
      this.$refs.pot_internals_modal.clear();
    },
  },

  // METHODS
  methods: {
    ...mapActions("inventory", ["apiCreatePotInternal", "getPotInternals"]), // inventory.js

    _show_deleted() {
      this.show_deleted = !this.show_deleted;
    },

    _save() {
      this.$refs.pot_internal.save();
    },

    _new_item() {
      this.showCreatePotInternal = true;
    },

    _closeNewModal() {
      this.showCreatePotInternal = false;
    },

    _showTab(index) {
      this.tab = index;
    },

    _itemSelected(item) {
      this.item = item;
      this.showPotInternalDetail = true;
    },

    _delete_item() {
      if (this.item != null && this.item.id > 0) {
        this.item.active = !this.item.active;
        this.apiSavePotInternal(this.item);
      }
    },
  },

  // COMPONENTS
  components: {
    PotInternalDetail,
    CreatePotInternal,
  },
};
</script>
